var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloads({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 28",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 15.875C5.62132 15.875 6.125 16.3787 6.125 17V21C6.125 21.2321 6.21719 21.4546 6.38128 21.6187C6.54538 21.7828 6.76794 21.875 7 21.875H21C21.2321 21.875 21.4546 21.7828 21.6187 21.6187C21.7828 21.4546 21.875 21.2321 21.875 21V17C21.875 16.3787 22.3787 15.875 23 15.875C23.6213 15.875 24.125 16.3787 24.125 17V21C24.125 21.8288 23.7958 22.6237 23.2097 23.2097C22.6237 23.7958 21.8288 24.125 21 24.125H7C6.1712 24.125 5.37634 23.7958 4.79029 23.2097C4.20424 22.6237 3.875 21.8288 3.875 21V17C3.875 16.3787 4.37868 15.875 5 15.875Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.2045 11.2045C8.64384 10.7652 9.35616 10.7652 9.7955 11.2045L14 15.409L18.2045 11.2045C18.6438 10.7652 19.3562 10.7652 19.7955 11.2045C20.2348 11.6438 20.2348 12.3562 19.7955 12.7955L14.7955 17.7955C14.3562 18.2348 13.6438 18.2348 13.2045 17.7955L8.2045 12.7955C7.76517 12.3562 7.76517 11.6438 8.2045 11.2045Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 3.875C14.6213 3.875 15.125 4.37868 15.125 5V17C15.125 17.6213 14.6213 18.125 14 18.125C13.3787 18.125 12.875 17.6213 12.875 17V5C12.875 4.37868 13.3787 3.875 14 3.875Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloads);
export default __webpack_public_path__ + "static/media/downloads.d043d3337c38da7abd1b55392518a526.svg";
export { ForwardRef as ReactComponent };